module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('p', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part001"
    }
  }, [_vm._v("Part 1 - April 1996")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2 - November")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3 - November 27-December 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4 - December 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 5 - December 8-9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 6 - December 10-23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 7 - Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 8 - Saint Stephen’s Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 9 - The Price of Miracles December 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda April 24, 1997")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0